import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function PriceBox() {
  return <section id="pricing" className="py-12 px-4 bg-white relative z-10 overflow-hidden" data-id="element-129">
      <div className="max-w-2xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0a1a3a] rounded-2xl border-[3px] border-blue-400/70 relative overflow-hidden shadow-2xl" data-id="element-131">
          {/* Header Badge */}
          <div className="bg-blue-600 text-white font-extrabold py-3 px-4 text-center text-sm uppercase tracking-wider" data-id="element-132">
            OFERTA DE LANZAMIENTO EXCLUSIVA
          </div>

          <div className="p-6 md:p-8" data-id="element-133">
            {/* Title */}
            <h3 className="text-2xl md:text-3xl font-extrabold text-center uppercase tracking-wide mb-4 text-white" data-id="element-134">
              PACK DISEÑO MESAS Y ESPEJOS INFINITOS
            </h3>

            {/* Animated 5-in-1 Pack Image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="mb-4 flex justify-center" data-id="element-135">
              <motion.img src="https://cdn.magicpatterns.com/uploads/u1p8nw3zPCP3W7d9PdFZrS/5_en_1.png" alt="Pack 5 en 1 - Mesas y Espejos Infinitos" width={448} height={300} loading="lazy" decoding="async" className="w-full max-w-md h-auto" style={{
              willChange: 'transform'
            }} animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-136" />
            </motion.div>

            {/* Pricing */}
            <div className="text-center mb-1" data-id="element-137">
              <p className="text-sm text-gray-400 font-medium" data-id="element-138">
                Antes{' '}
                <span className="line-through text-[#E13756]" data-id="element-139">$49.990 ARS</span>
              </p>
            </div>

            <div className="text-center mb-4" data-id="element-140">
              <p className="md:text-6xl text-[56px] font-[800] text-[#03F003] mb-[40px]" data-id="element-141">
                $19.990{' '}
                <span className="text-lg font-normal text-[#FBFDFF]" data-id="element-142">ARS</span>
              </p>
            </div>

            {/* Cuotas sin interés badge */}
            <div className="flex justify-center mb-4" data-id="element-143">
              <motion.div className="relative overflow-hidden rounded-lg border-2 border-yellow-400 bg-gradient-to-r from-yellow-400/10 to-yellow-500/10 px-6 py-3 pt-[8px] pb-[8px] pl-[24px] pr-[24px]" data-id="element-144">
                <p className="text-center md:text-xl uppercase tracking-wide text-[16px] font-[700] font-[Montserrat,_sans-serif] text-[#50CA2F]" data-id="element-145">
                  💳 Hasta 3 cuotas sin interés
                </p>
                {/* Shimmer / shine effect sliding left to right every 3 seconds */}
                <motion.div className="absolute inset-0 pointer-events-none" style={{
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.25) 50%, transparent 100%)',
                width: '60%'
              }} animate={{
                x: ['-100%', '250%']
              }} transition={{
                duration: 1,
                repeat: Infinity,
                repeatDelay: 2,
                ease: 'easeInOut'
              }} data-id="element-146" />
              </motion.div>
            </div>

            {/* Oferta válida solo por hoy */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="mb-4" data-id="element-147">
              <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-red-600/20 via-orange-500/20 to-red-600/20 border-2 border-red-500/60 px-4 py-3 text-center pt-[8px] pb-[8px] mt-[0px] mb-[43px]" data-id="element-148">
                <motion.div animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-149">
                  <p className="text-base md:text-lg text-red-400 uppercase tracking-wide font-[700]" data-id="element-150">
                    Oferta válida solo por hoy
                  </p>
                </motion.div>
                <p className="text-sm font-bold text-orange-300 mt-1 capitalize" data-id="element-151">
                  {new Date().toLocaleDateString('es-AR', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                </p>
                {/* Shimmer effect */}
                <motion.div className="absolute inset-0 pointer-events-none" style={{
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,100,50,0.15) 50%, transparent 100%)',
                width: '50%'
              }} animate={{
                x: ['-100%', '300%']
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatDelay: 3,
                ease: 'easeInOut'
              }} data-id="element-152" />
              </div>
            </motion.div>

            {/* Live Viewers Counter */}

            {/* CTA Button */}
            <a href="https://www.sinfinstudio.online/cart/44075753078820:1" rel="noopener noreferrer" className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-extrabold py-5 rounded-lg shadow-lg hover:shadow-xl transition-all flex mb-4 text-[18px] pt-[30px] pb-[30px] gap-[8px] items-center justify-center" data-id="element-153">
              SÍ, QUIERO MI PACK AHORA
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-154">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-155"></path>
              </svg>
            </a>

            {/* Payment Security Section */}
            <div className="bg-white rounded-2xl p-4 mt-[50px] mb-[18px]" data-id="element-156">
              {/* Header with Lock Icon */}
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-157">
                <svg className="w-6 h-6 text-[#1E4620]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-158">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-159" />
                </svg>
                <h4 className="text-lg md:text-xl font-extrabold text-[#1E4620] uppercase tracking-wide" data-id="element-160">
                  Método de Pago Seguro y Protegido
                </h4>
              </div>

              {/* Mercado Pago Block */}
              <div className="bg-[#E3F2FD] rounded-xl p-4 mb-4" data-id="element-161">
                <div className="flex justify-center mb-4" data-id="element-162">
                  <img src="https://cdn.magicpatterns.com/uploads/nRXxaZudtgrN28tXfRFyoX/medios_de_pagos.jpg" alt="Mercado Pago - Medios de Pago" width={896} height={256} loading="lazy" decoding="async" className="h-48 md:h-64 object-contain w-full max-w-4xl" data-id="element-163" />
                </div>
                <h5 className="text-center text-sm md:text-base font-extrabold text-[#009EE3] uppercase mb-3" data-id="element-164">
                  Tu compra está respaldada por Mercado Pago
                </h5>
                <div className="text-center bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-4 border-2 border-orange-300" data-id="element-165">
                  <p className="text-lg font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-red-600 uppercase mb-2" data-id="element-166">
                    🔥 OFERTA VÁLIDA SOLO POR HOY
                  </p>
                  <p className="text-sm font-bold text-orange-700" data-id="element-167">
                    {new Date().toLocaleDateString('es-AR', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                  </p>
                </div>
              </div>

              {/* MercadoLíder Platinum */}
              <div className="border-t border-gray-200 pt-4" data-id="element-168">
                <div className="flex items-center justify-center gap-2 mb-3" data-id="element-169">
                  <svg className="w-5 h-5 text-[#1E4620]" fill="currentColor" viewBox="0 0 20 20" data-id="element-170">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-171" />
                  </svg>
                  <h6 className="text-sm font-extrabold text-[#1E4620] uppercase" data-id="element-172">
                    MercadoLíder Platinum
                  </h6>
                </div>
                <p className="text-xs text-center text-[#388E3C] font-bold mb-4" data-id="element-173">
                  ¡Es uno de los mejores del sitio!
                </p>

                {/* Progress Bar */}
                <div className="h-2 bg-gradient-to-r from-red-500 via-yellow-400 to-green-500 rounded-full mb-4" data-id="element-174"></div>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-4 text-center" data-id="element-175">
                  <div data-id="element-176">
                    <p className="text-2xl font-extrabold text-gray-800" data-id="element-177">
                      2436
                    </p>
                    <p className="text-[10px] text-gray-600 leading-tight" data-id="element-178">
                      Ventas en los
                      <br data-id="element-179" />
                      últimos 60 días
                    </p>
                  </div>
                  <div data-id="element-180">
                    <div className="flex justify-center mb-1" data-id="element-181">
                      <div className="relative" data-id="element-182">
                        <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-183">
                          <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" data-id="element-184" />
                        </svg>
                        <svg className="absolute -bottom-1 -right-1 w-4 h-4 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-185">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-186" />
                        </svg>
                      </div>
                    </div>
                    <p className="text-[10px] text-gray-600 leading-tight" data-id="element-187">
                      Brinda buena
                      <br data-id="element-188" />
                      atención
                    </p>
                  </div>
                  <div data-id="element-189">
                    <div className="flex justify-center mb-1" data-id="element-190">
                      <div className="relative" data-id="element-191">
                        <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-192">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-193" />
                        </svg>
                        <svg className="absolute -bottom-1 -right-1 w-4 h-4 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-194">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-195" />
                        </svg>
                      </div>
                    </div>
                    <p className="text-[10px] text-gray-600 leading-tight" data-id="element-196">
                      Despacha sus
                      <br data-id="element-197" />
                      productos a tiempo
                    </p>
                  </div>
                </div>
              </div>

              {/* Trust Badges Row - Moved to bottom */}
              <div className="flex flex-row justify-center items-center gap-6 mt-4 pt-4 border-t border-gray-200" data-id="element-198">
                {/* 7 Days Guarantee */}
                <div className="flex flex-col items-center" data-id="element-199">
                  <img src="https://cdn.magicpatterns.com/uploads/33L4RSMNtqLmpgL3G8P8RF/7_dias.jpg" alt="7 Días Garantía" width={96} height={96} loading="lazy" decoding="async" className="w-24 h-24 object-contain" data-id="element-200" />
                </div>

                {/* Secure Purchase */}
                <div className="flex items-center gap-3" data-id="element-201">
                  <div className="relative w-16 h-16" data-id="element-202">
                    <svg className="w-full h-full text-[#388E3C]" fill="currentColor" viewBox="0 0 20 20" data-id="element-203">
                      <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-204" />
                    </svg>
                    <svg className="absolute bottom-0 right-0 w-6 h-6 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-205">
                      <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" data-id="element-206" />
                    </svg>
                  </div>
                  <div data-id="element-207">
                    <p className="text-lg font-extrabold text-[#388E3C] uppercase leading-tight" data-id="element-208">
                      Compra Segura
                    </p>
                    <p className="text-xs font-bold text-[#388E3C]" data-id="element-209">
                      Compra 100% Segura
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}